<template>
  <div v-if="isMobile()" id="app">
    <v-app>
      <router-view />
    </v-app>
  </div>
  <div v-else>
    <p>unAuthorized access from desktop devices</p>
  </div>
</template>

<script>
export default {
  name: "Init",
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.v-input__slot::before {
  border-color: rgb(207, 207, 207) !important;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.search-panel {
  position: fixed;
  top: 56px;
  z-index: 1;
  width: 100%;
}
</style>
